import { ca } from '@cian/analytics';

export function trackDeveloperFlatsLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_developersFlats',
    label: 'all',
    useLastProducts: true,
  });
}
